import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { useTableContext } from '../SearchResultsTable/TableContext';
import { useCreateActionEventHandlers } from '../SearchResultsTable/useCreateActionEventHandlers';
import { isDocument } from '../SearchResultsTable/utils';
export function Assistant() {
    const { selected } = useTableContext();
    const history = useHistory();
    const { isFeatureAvailable } = useCompanyFeatures();
    const enabled = isFeatureAvailable('PLAI_AGENT');
    const documentIds = selected.filter(isDocument).map(({ entityId }) => entityId);
    const eligibleDocumentsCount = documentIds.length;
    const disabled = !eligibleDocumentsCount;
    const eventHandlers = useCreateActionEventHandlers('plai', () => {
        history.push({
            pathname: '/plai/chat',
            state: { documentId: documentIds },
        });
    });
    if (!enabled) {
        return null;
    }
    return (<Button type="button" size="small" disabled={disabled} appearance="glass" {...eventHandlers}>
      <Falcon icon="sparkles"/>
      <Trans comment="Bulk action: Assistant" context="search">
        PLAI
      </Trans>
    </Button>);
}
